var map = {
	"./apache.svg": "90c3",
	"./go.svg": "5c1d",
	"./javascript.svg": "c126",
	"./kong.svg": "f065",
	"./nginx.svg": "b7ba",
	"./php.svg": "1dba",
	"./python.svg": "1df5",
	"./ruby.svg": "d16e",
	"./swift.svg": "989d",
	"./traefik.svg": "262f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "93b4";